import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useParams } from "react-router-dom";
import { LoadingPanel } from "../../../components/layout/Loading";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { checkAcessRights, formatIndianNumber } from "../../../_helper/helper";
import { EXCEL_EXPORT_ACCESS, PRINT_ACCESS } from "../../../_contstants/common";
import AlertBox from "../../../components/common/AlertBox";
import moment from "moment";
import { GetLeadSourceAnalysisReport } from "../services/reports.services";

const LeadSourceAnalysisReportView = () => {
  const gridRef = React.useRef<any>(null);
  const dispatch = useAppDispatch();
  // const navigate = useNavigate();
  const params = useParams();
  const isExcelExportAccess = checkAcessRights(
    "/leadsourceanalysisreportform",
    EXCEL_EXPORT_ACCESS
  );
  const isPrintAccess = checkAcessRights(
    "/leadsourceanalysisreportform",
    PRINT_ACCESS
  );

  const filterFromDate = params?.filterFromDate;
  const filterToDate = params?.filterToDate;
  const filterSector = params?.filterSector;
  const LeadSource = params?.LeadSource;
  const AssignedUserId = params?.AssignedUserId;

  const loading = useAppSelector((state) => state.reports.loading);
  const LeadSourceAnalysisListForReport = useAppSelector(
    (state) => state.reports.LeadSourceAnalysisListForReport
  );

  const [uiLoading, setLoading] = React.useState<boolean>(true);

  useEffect(() => {
    setLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (filterToDate && filterFromDate) {
      const payload = {
        FromDate: filterFromDate !== "0" ? filterFromDate : "",
        ToDate: filterToDate !== "0" ? filterToDate : "",
        SectorID: filterSector !== "0" ? filterSector : 0,
        Source: LeadSource !== "0" ? LeadSource : "",
        AssignedUserId: AssignedUserId !== "0" ? AssignedUserId : 0,
      };
      dispatch(GetLeadSourceAnalysisReport(payload));
    }
  }, []);

  const handleExportExcel = () => {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.table_to_sheet(
      document.querySelector(".table-bordered")
    );
    XLSX.utils.book_append_sheet(wb, ws, "LeadSourceAnalysisReport");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(data, "leadsourceanalysisreport.xlsx");
  };

  if (uiLoading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      <div
        className="report-container"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px 10px",
        }}
      >
        <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
          Lead Source Analysis Report{" "}
          <span style={{ fontSize: 15 }}>
            {LeadSourceAnalysisListForReport &&
              LeadSourceAnalysisListForReport.length > 0 &&
              `(
              ${
                filterFromDate !== "0"
                  ? moment(filterFromDate, "YYYY-MM-DD").format("DD/MM/YYYY")
                  : ""
              }${filterFromDate !== "0" && filterToDate !== "0" ? " to " : ""}${
                filterToDate !== "0"
                  ? moment(filterToDate, "YYYY-MM-DD").format("DD/MM/YYYY")
                  : " "
              }
              )`}
          </span>
        </Typography.h4>
        <div className="printbuttons">
          {isPrintAccess &&
            LeadSourceAnalysisListForReport &&
            LeadSourceAnalysisListForReport.length > 0 && (
              <Button
                style={{ marginRight: 5 }}
                type="button"
                fillMode={"solid"}
                themeColor={"primary"}
                onClick={() => window.print()}
              >
                Print
              </Button>
            )}

          {isExcelExportAccess &&
            LeadSourceAnalysisListForReport &&
            LeadSourceAnalysisListForReport.length > 0 && (
              <Button
                type="button"
                fillMode={"solid"}
                themeColor={"primary"}
                onClick={handleExportExcel}
              >
                Excel Export
              </Button>
            )}
        </div>
      </div>
      {LeadSourceAnalysisListForReport &&
      LeadSourceAnalysisListForReport.length > 0 ? (
        <div className="table-responsive" style={{ margin: "0 10px" }}>
          <table className="table table-bordered reportScreens lead-report">
            <thead>
              <tr>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  No
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Lead Source
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Total Leads
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Converted Bookings
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Conversion %
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-end"
                >
                  Total Revenue
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Cost per Lead
                </th>
              </tr>
            </thead>
            <tbody>
              {LeadSourceAnalysisListForReport &&
                LeadSourceAnalysisListForReport.length > 0 &&
                LeadSourceAnalysisListForReport?.map(
                  (LeadSourceAnalysis: any, index: number) => (
                    <tr key={index}>
                      <td className="text-center">{index + 1}</td>
                      <td className="text-center">
                        {LeadSourceAnalysis?.Source || ""}
                      </td>
                      <td className="text-center">
                        {LeadSourceAnalysis?.TotalLeads || ""}
                      </td>
                      <td className="text-center">
                        {LeadSourceAnalysis?.ConvertedBookings || ""}
                      </td>
                      <td className="text-center">
                        {LeadSourceAnalysis?.ConversionPer
                          ? LeadSourceAnalysis?.ConversionPer + " %"
                          : ""}
                      </td>
                      <td className="text-end">
                        {LeadSourceAnalysis?.TotalRevenue
                          ? formatIndianNumber(LeadSourceAnalysis?.TotalRevenue)
                          : ""}
                      </td>
                      <td className="text-center">
                        {LeadSourceAnalysis?.CostPerLead || ""}
                      </td>
                    </tr>
                  )
                )}
            </tbody>
          </table>
        </div>
      ) : (
        <AlertBox style={{ margin: "0 10px 10px" }} />
      )}
    </>
  );
};

export default LeadSourceAnalysisReportView;
